export default __webpack_public_path__ + "static/media/777 milestone badge.6e01b69d.svg";